module.exports = __webpack_public_path__ + "img/kma_gallery6.cc5d360c.jpg";